import { useContext, useState } from "react";
import { useNavigate } from "../../router";
import {
  Breadcrumb,
  Button,
  Typography,
  message,
} from "antd";
import {
  ArrowLeftOutlined,
} from "@ant-design/icons";

import { Context } from "../../context";
import ReelForm from "../../components/ManageReels";

import "./styles.css";

const { Title, Text } = Typography;

const AddReel = () => {
  const navigate = useNavigate();
  const { createReel, formatReelsApiError } = useContext(Context);

  const [loading, setLoading] = useState(false);

  const handleSubmit = async (values) => {
    try {
      setLoading(true);

      if (!values.seriesId) {
        message.error("Please select a webseries");
        return;
      }

      const payload = {
        title: values.title?.trim(),
        hindiTitle: values.hindiTitle?.trim() || null,
        seriesId: String(values.seriesId),
        playbackUrl: values.playbackUrl?.trim() || null,
        iosPlaybackUrl: values.iosPlaybackUrl?.trim() || null,
        thumbnailImage: values.thumbnailImage?.trim() || null,
        priority: values.priority ?? null,
        status: Boolean(values.status),
      };

      await createReel(payload);

      message.success("Reel created successfully");

      navigate("/reels");
    } catch (error) {
      console.error(error);

      message.error(
        formatReelsApiError(error?.data) ||
          error?.message ||
          "Failed to create reel"
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="reels-page">
      <Breadcrumb style={{ marginBottom: 16 }}>
        <Breadcrumb.Item>
          Reels
        </Breadcrumb.Item>

        <Breadcrumb.Item>
          Add Reel
        </Breadcrumb.Item>
      </Breadcrumb>

      <div className="reels-page-header">
        <div>
          <Title level={4}>
            Add Reel
          </Title>

          <Text type="secondary">
            Create a new reel
          </Text>
        </div>

        <Button
          icon={<ArrowLeftOutlined />}
          onClick={() =>
            navigate("/reels")
          }
        >
          Back
        </Button>
      </div>

      <ReelForm
        loading={loading}
        submitLabel="Create Reel"
        onSubmit={handleSubmit}
      />
    </div>
  );
};

export default AddReel;
